import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../_services/auth.service';



@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate  {
  constructor(private authService: AuthService, private router: Router) {
    console.log("auth guard called")
  }

  canActivate(): boolean {

    return this.checkAuth();
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log("can activate child called")
    return this.checkAuth();
  }

  
  canLoad(): boolean {
    return this.checkAuth();
  }

  private checkAuth(): boolean {
    if (this.authService.isLoggedIn()) {
     console.log( "returning true")
      return true;
    } else {
    console.log( "returnining false not logged in")
      this.router.navigate(['/login']);
      return false;
    }
  }

}